import { useRelatorioAM } from "@/hooks/useRelatorioAM";
import { formatMessageError } from "@/utils/formatMessageError";
import { App, Form, Input, Modal } from "antd";
import { useState } from "react";

interface IFormValues {
  motivoCancelamento: string;
}

export function ModalCancelarRAM({
  isOpen,
  onClose,
  ramId,
  reloadItems,
}: {
  isOpen: boolean;
  onClose: () => void;
  ramId: number;
  reloadItems: () => void;
}) {
  const [form] = Form.useForm<IFormValues>();
  const { message, notification } = App.useApp();
  const { cancelarRelatorioAMApi, listaRelatorioAM, removeRelatorioAM } =
    useRelatorioAM();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async ({ motivoCancelamento }: IFormValues) => {
    try {
      setIsLoading(true);
      message.loading({
        content: "Cancelando Relatório de Auditoria e Monitoria...",
        key: "loading",
        duration: 0,
      });
      await cancelarRelatorioAMApi(ramId, motivoCancelamento);

      message.destroy("loading");
      setIsLoading(false);

      const relatorioAMOffline = listaRelatorioAM.find((r) => r.id === ramId);

      if (relatorioAMOffline) {
        removeRelatorioAM(relatorioAMOffline.offlineId!);
      }

      notification.success({
        message: "Relatório de Auditoria e Monitoria cancelado com sucesso!",
      });

      form.resetFields();
      onClose();

      reloadItems();
    } catch (error) {
      console.error(
        "Erro ao cancelar o relatório de auditoria e monitoria:",
        error
      );
      message.destroy("loading");
      setIsLoading(false);
      const messageError = formatMessageError(error);
      notification.error({
        message:
          "Não foi possível cancelar o relatório de auditoria e monitoria",
        description: messageError,
      });
      return;
    }
  };

  return (
    <Modal
      title="Cancelar Relatório de Auditoria e Monitoria"
      open={isOpen}
      onCancel={() => {
        form.resetFields();
        onClose();
      }}
      okButtonProps={{
        form: "form-cancelar-relatorio-am",
        htmlType: "submit",
        danger: true,
        ghost: true,
        loading: isLoading,
        disabled: isLoading,
      }}
      cancelButtonProps={{
        disabled: isLoading,
      }}
      okText="Confirmar"
      cancelText="Fechar"
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={handleSubmit}
        id="form-cancelar-relatorio-am"
      >
        <Form.Item
          label="Descreva o motivo para o cancelamento do relatório de auditoria e monitoria"
          name="motivoCancelamento"
          rules={[{ required: true }]}
        >
          <Input.TextArea
            rows={4}
            placeholder="Informe o motivo do cancelamento"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
